module.exports = __webpack_public_path__ + "img/1521487253.456fcb32.jpg";